import { getToken } from 'config/axiosInstance';
import { io } from 'socket.io-client';

const token = getToken();
const URL = process.env.REACT_APP_SOCKET_URL;
// console.log('URL', URL)
const socket = io(URL, {
    transports: ["websocket"],
    auth: {
        token
    }
});
// Handle connection errors
socket.on("connect_error", (err) => {
    console.error("Connection error:", err.message);
});
export { socket };